import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import { AuthContext } from 'contexts/authentication/AuthContext';

function PrivateRoute({
  component: Component,
  ...rest
}) {
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={
        ({ location }) => (
          isAuthenticated ? <Component /> : <Redirect to={{ pathname: '/', state: { from: location } }} />
        )
      }
    />
  );
}

PrivateRoute.propTypes = {
  component: PropTypes.shape().isRequired,
};

export default PrivateRoute;
